import { TextField, Typography } from '@mui/material';
import { Autocomplete } from "@mui/material";

const ReportingInternList = ({ listData, ...props }) => {
    return (
        <>
            <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748b', letterSpacing: '0.06em', textTransform: 'uppercase', mb: 0.75 }}>
                {listData.label}
            </Typography>
            <Autocomplete
                value={listData.value}
                onChange={(event, newValue) => {
                    props.handleDataChange(newValue);
                  }}
                getOptionLabel={option => option.value}
                getOptionSelected={(option, value) => option.id === value.id}
                options={listData.data}
                noOptionsText={"Aucun client trouvé."}
                renderInput={(params) => <TextField {...params} variant="outlined" size="small" />}
                disableClearable
                loading={listData.isLoading}
                loadingText="chargement..."
                size="small"
            />
        </>
    )
}

export default ReportingInternList